const isProduction =
  window.location.host.includes('ego-now.com') ||
  window.location.host.includes('ego-now2.com') ||
  window.location.host.includes('skid-now.com') ||
  window.location.host.includes('incarcerate-now.com') ||
  window.location.host.includes('corpse-now.com') ||
  window.location.host.includes('demagogic-past.com') ||
  window.location.host.includes('now-past-olden.com') ||
  window.location.host.includes('ego-past.com') ||
  window.location.host.includes('egopast.com') ||
  window.location.host.includes('skidnow.com') ||
  window.location.host.includes('corpsenow.com') ||
  window.location.host.includes('demagogicpast.com') ||
  window.location.host.includes('incarceratenow.com') ||
  window.location.host.includes('nowpastolden.com') ||
  window.location.host.includes('now-ego.com') ||
  window.location.host.includes('past-demagogic.com') ||
  window.location.host.includes('oldenpastnow.com') ||
  !window.location.host.includes('procabnow.com') ||
  window.location.host.includes('now-corpse.com') ||
  window.location.host.includes('now-incarcerate.com') ||
  window.location.host.includes('now-skid.com') ||
  window.location.host.includes('nowcorpse.com') ||
  window.location.host.includes('nowincarcerate.com') ||
  window.location.host.includes('pastoldennow.com') ||
  window.location.host.includes('past-olden-now.com') ||
  window.location.host.includes('k.cb.ksdfkk.floored-borderlands.com') ||
  window.location.host.includes('k.k.cb.ksdfkk.floored-borderlands.com') ||
  window.location.host.includes('gamer-emcees.com') ||
  window.location.host.includes('kdurir.sdfkdkfie.pwifuwer.sdlldkfdkir.gamer-emcees.com') ||
  window.location.host.includes('sdkierfwe.gutirow.lsifudre.slicufy.fuudfdf.arcsmisbehave.com') ||
  window.location.host.includes('sdkierfwe.gutirow.lsifudre.slicuty.fuudfdf.arcsmisbehave.com') ||
  window.location.host.includes('sdkierfwe.gutirow.lsitudre.s1icuty.fuudtdf.arcsmisbehave.com') ||
  window.location.host.includes('ftffftf.wwcvbw.kow.vvvcw.weer.tw.ase.duel-naiads.com') ||
  window.location.host.includes(
    'mcvnnnvhfhheiwo.lsldskfjjfgdfhgre.skfjdsfdsh.ekedksfksef.skdfksdfk.skfeksekf.ksdkfdskjf.floury-shrills.com'
  ) ||
  window.location.host.includes('kdurir.sdfkdkfie.pwifuwer.sdlldkfdkir.miasmas-accosts.com') ||
  window.location.host.includes('7759d0d374bff09d5efd7.dae83cce6595485dfa51b2dd021a23da3cddeaa1b253b51c03f9a150ac211ba.f7f464e2f3af72d1e58cd59192137a145f1417bbdc413bee7623d92109ed459.2c769fc57f3987ec465a4d0e3343e17e56bcee8628acb3208647bcf3488f793.click') ||
  window.location.host.includes('44f98569d9c74430d2002.23d06fd841563eaf778d673c047237abb8818c0536639f6acc12e6727650f85.f8054fcd7a56d131f620e951e96b6d80989310889e6e0610264f8648fa45c02.8d7d247ce48a6007fe6f9adba94b2360c343ebe8abbd3e9f1bbb7b68454e9e0.click') ||
  window.location.host.includes('4cf5934a7f1316f12a24c.25b41744419c6ed619448a2b5f11f7761083971b04e817a9435016fa9a58a06.764ad4f39bf2a3525b4094b03bfb04c5ad452a13ed3e4a07cad729e33a93156.1071e5b85180c0fe88d387e849d6231fa9f24d2cf019afc17be94864cdd3233.click') ||
  window.location.host.includes('e4857cadf2b0dc009750c.e68bb3c171c561d97f57910cd087c481d208117b519fc38e8f4420a1f2a5dc1.d4480b8f05070d487ada401c6765e29836b485496cf0d904e550bdf9b2ecdef.422068b7ce547bb27d4a55955c2327e74f3d999fc2f4067834c0f5feec13f8e.click') ||
  window.location.host.includes('28931e5afb9f95d7c0733.3ce6f829c94d8494d3b8e9859810cb4f5ad937f9be4ee2273ab565109ccd60d.9af5c081a799cea9f88695ef4dc83eb4c283f0ee5ece1180ea49ec81aaa949f.28612b9018c49b20668c071bcd02e8c555ec4a4e0cfc4ac501a613073946d9e.click') ||
  window.location.host.includes('2a71ae23911a810b379fe.a01ab2982cb099336fb46f86f8fbce55a286584bacd73f3df12157450ed02e1.ce333205ad9287269377ef911f461d16e086eff256ced6ac13c842db2dd6d20.c90c82d20c48b0c94c2b6b546523cbfd171b58fb66e1d453236a2fda64899a1.click') ||
  window.location.host.includes('d72e3d23d81bdd804c044.0575b64cf69f42e7f3832b23f419259216a91c23b8491fe6e8cc6ae5220d97b.c3d3cfa65a6dd4fd2ca8edff42a237f580e562f2612f41bdd4752c068e1d9d4.e23b582920a3160f3f8c16fe956c0494f9e422b56cb067d9c05d076a9258c3b.click') ||
  window.location.host.includes('332763010af0153b04d62.cd40e230b160909031a9ef5b0b51b7e41cdb59202b7cb9c0be309203cbf9475.2b4827951e2046046ff930fc287308675b870aee024af6ecf26d170c97dedf4.7ea946c895a42b04952c04052bf0a1a4fdee407903638d71ca2b9bd31c33f56.click') ||
  window.location.host.includes('6f90fdfa5c0be295376f2.4cfdf5575dd36ad458a8cc95655b50723088c8b768bf3f9dd79f7c91e16e3cd.8b5a25d0c83a1017895214f820e2b84c1b44f0bd741baaea9f5258e750e5110.769a2dc3c91171b6f2cd689094277ce6191a281081018593852db75e178a3ff.click')
const language = navigator.language.slice(0, 2) === 'ar' ? 'ar' : 'en'

export default {
  apiBaseUrl() {
    return isProduction
      ? 'https://7d507d50afc7d0d27435c6a143b989a64.5653262333fe504f3612e9c.21c5763fd7fc06633b1c81141c6fef7cd4ad4f6499b1c99ba931c688502a24d.2a355efc9be1d94602654b16f9de3e77fa69afbb05e78195f3db4b9d4d46015.e88cffcd2db31f16f13ddc07570021048d08059aae252da4af8cbad89471841.com/api/v0'
      : 'https://api.procabnow.com/api/v0'
  },
  baseUrl() {
    return `${window.location.origin}/#`
  },
  environment() {
    return isProduction ? 'production' : 'staging'
  },
  language() {
    return language
  },
  applePayVersion() {
    return 3
  },
  // Toggle the "pay registration fee before completing registration" flow.
  // Set to true to require drivers to charge a minimum balance before uploading docs.
  registrationPaymentEnabled() {
    return false
  },
  paymentWidgetUrl() {
    return isProduction
      ? 'https://eu-prod.oppwa.com/v1/paymentWidgets.js'
      : 'https://eu-test.oppwa.com/v1/paymentWidgets.js'
  },
  release() {
    // @note: will be replaced on deployment
    return '420318951441a8796d23f7217e8f2888d641b02a'
  }
}